import cookieHelper from './cookieHelper';

const isJwtTokenStored = () =>
  cookieHelper.get(process.env.REACT_APP_TN) && cookieHelper.get(process.env.REACT_APP_TN) !== '';

const isJwtRefTokenStored = () =>
  cookieHelper.get(process.env.REACT_APP_TNR) && cookieHelper.get(process.env.REACT_APP_TNR) !== '';

const getJwtToken = () => (isJwtTokenStored() ? cookieHelper.get(process.env.REACT_APP_TN) : null);

const setJwtToken = jwtToken => sessionStorage.setItem(process.env.REACT_APP_TN, jwtToken);

const removeJwtToken = () => sessionStorage.removeItem(process.env.REACT_APP_TN);

const getJwtRefToken = () => (isJwtRefTokenStored() ? cookieHelper.get(process.env.REACT_APP_TNR) : null);

const setJwtRefToken = jwtRefToken => sessionStorage.setItem(process.env.REACT_APP_TNR, jwtRefToken);

const removeJwtRefToken = () => sessionStorage.removeItem(process.env.REACT_APP_TNR);

const getHeaders = () => ({
  Authorization: isJwtTokenStored() ? `Bearer ${getJwtToken()}` : '',
  Accept: 'application/json'
});

const getApiPrefix = () => ( isJwtTokenStored() ? '/user' : '');

export {
  isJwtTokenStored,
  getJwtToken,
  setJwtToken,
  removeJwtToken,
  getHeaders,
  getApiPrefix,
  isJwtRefTokenStored,
  getJwtRefToken,
  setJwtRefToken,
  removeJwtRefToken
};